import { useEffect, useState } from 'react';
import { subscribeToLatestAppVersion } from '@/services/configService';
import type { CameraMode } from '@/types';

/**
 * Latest published app version for the product line of a view, 0 until known.
 * A device is only "outdated" against its own line: the two ship on separate schedules.
 */
export function useLatestAppVersion(cameraMode: CameraMode | undefined): number {
  const [latestVersion, setLatestVersion] = useState(0);

  useEffect(() => {
    setLatestVersion(0);
    return subscribeToLatestAppVersion(cameraMode, setLatestVersion);
  }, [cameraMode]);

  return latestVersion;
}
